import { render, staticRenderFns } from "./work_add.vue?vue&type=template&id=7fa24278&scoped=true&"
import script from "./work_add.vue?vue&type=script&lang=js&"
export * from "./work_add.vue?vue&type=script&lang=js&"
import style0 from "./work_add.vue?vue&type=style&index=0&id=7fa24278&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa24278",
  null
  
)

export default component.exports